import Vue from 'vue'
import * as forge from 'node-forge' // rsa加密
import { toUrlSafeBase64, toNormalBase64, convertBase64toPEM } from '@/utils/base64-utils.js'
import x509 from 'node-forge/lib/x509.js'
import util from 'node-forge/lib/util.js'
import hmac from 'node-forge/lib/hmac.js'
import config from '@/common/config'

// 生成获取账号密码登录签名
const getLoginSignStr = function(userInfo, roleId, loginType, nonceStr, timeStamp) {
  const appSecret = util.decode64(toNormalBase64(sessionStorage.getItem('isCuser')==1?config.CAPP_SECRET:config.BAPP_SECRET))
  const params = `loginType=${encodeURIComponent(loginType)}&nonceStr=${encodeURIComponent(nonceStr)}&roleId=${encodeURIComponent(roleId)}&timestamp=${encodeURIComponent(timeStamp)}&userInfo=${encodeURIComponent(userInfo)}`
  const messageBytes = util.encodeUtf8(params)
  const hmacInstance = hmac.create()
  hmacInstance.start('sha256', appSecret)
  hmacInstance.update(messageBytes)
  const digest = hmacInstance.digest()
  // 取bytes转换为base64
  const b64String = util.encode64(digest.bytes())
  return toUrlSafeBase64(b64String)
}

// 生成退出登录的签名
const getLogoutSignStr = function(refreshToken, nonceStr, timestamp) {
  const params = `nonceStr=${encodeURIComponent(nonceStr)}&refreshToken=${encodeURIComponent(refreshToken)}&timestamp=${encodeURIComponent(timestamp)}`
  return createSignStr(params)
}
// 修改个人密码的签名
const getChangePwdSignStr = function(modifyPassWordInfo, nonceStr, timestamp) {
  const params = `modifyPassWordInfo=${encodeURIComponent(modifyPassWordInfo)}&nonceStr=${encodeURIComponent(nonceStr)}&timestamp=${encodeURIComponent(timestamp)}`
  return createSignStr(params)
}

// 用户管理 -新增B端员工生产签名
const getSignStrCommon = function(object) {
  let paramsArray = Object.keys(object)
  let params = ''
  paramsArray.forEach((key, index) => {
    params += `${key}=${encodeURIComponent(object[key])}`
    if (paramsArray.length != index + 1) {
      params += '&'
    }
  })
  console.log('签名信息----', params)
  return createSignStr(params)
}

//生成签名sign公共方法
const createSignStr = function(params) {
  const appSecret = util.decode64(toNormalBase64(sessionStorage.getItem('isCuser')==1?config.CAPP_SECRET:config.BAPP_SECRET))
  const messageBytes = util.encodeUtf8(params)
  const hmacInstance = hmac.create()
  hmacInstance.start('sha256', appSecret)
  hmacInstance.update(messageBytes)
  const digest = hmacInstance.digest()
  // 取bytes转换为base64
  const b64String = util.encode64(digest.bytes())
  return toUrlSafeBase64(b64String)
}

// RSA加密--使用公钥对密码加密
const encryptRSA = function(word, pubKeyUrlSafe) {
  const utf8Word = forge.util.encodeUtf8(word)
  const pubKeyB64 = toNormalBase64(pubKeyUrlSafe)
  const pem = convertBase64toPEM(pubKeyB64, 'RSA PUBLIC KEY')
  const publicKey = x509.publicKeyFromPem(pem)
  var encryptedBytes = publicKey.encrypt(utf8Word)
  const b64String = forge.util.encode64(encryptedBytes)
  const b64StringUrlSafe = toUrlSafeBase64(b64String)
  return b64StringUrlSafe
}

// 获取应用基础路径（开发环境为/，生产环境为/cas或/acs）
const getAppBase = function() {
  // 通过检查当前页面路径来判断
  const pathname = window.location.pathname
  // 如果路径包含 /cas，说明部署在子目录下
  if (pathname.includes('/cas/') || pathname.startsWith('/cas')) {
    return '/cas'
  }
  // 如果路径包含 /acs，说明部署在子目录下
  if (pathname.includes('/acs/') || pathname.startsWith('/acs')) {
    return '/acs'
  }
  return ''
}

// 获取首页路径（用于window.location.href跳转）
const getHomePath = function() {
  return getAppBase() + '/#/'
}

// 获取支付页面路径（用于window.open）
const getPayPagePath = function(sessionId) {
  return getAppBase() + `/#/payPage?sessionid=${sessionId}`
}

export {
  encryptRSA,
  getLoginSignStr,
  getLogoutSignStr,
  getChangePwdSignStr,
  getSignStrCommon,
  getAppBase,
  getHomePath,
  getPayPagePath
}
